import {connect} from "react-redux"
import State from "../../ducks/state"
import {getMessageBannerThunk} from "../../ducks/messageBanner"
import getPersonalizedBanners from "../../utils/getPersonalizedBanners"
import {MESSAGE_BANNER_TYPE} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        messageBanner: {placements},
    } = state

    const items = getPersonalizedBanners(placements)
    const topBanner = placements.find(({name}) => name === MESSAGE_BANNER_TYPE.PLACEMENT_TOP_BANNER)
    const {autoplayTime, pauseOnHover, infinite} = topBanner?.content?.[0] || {
        pauseOnHover: "1",
        infinite: "1",
        autoplayTime: 4000,
    }
    return {
        items,
        autoplayTime,
        pauseOnHover: pauseOnHover === "1",
        infinite: infinite === "1",
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    getMessageBannerData: () => dispatch(getMessageBannerThunk()),
})

export default connect(mapStateToProps, mapDispatchToProps)
